// extracted by mini-css-extract-plugin
module.exports = {"s1k2ptrr":"s1k2ptrr","direction":"direction","align":"align","justify":"justify","gap":"gap"};